export const de = {
  whatsNew: {
    title: "Neuigkeiten",
    intro: "Das ist neu in Vamos Tamos.",
    teamsTitle: "Speichere deine Teams",
    teamsBody: "Speichere eine Aufstellung mit Namen und 4-stelliger PIN und lade sie jederzeit wieder.",
    languagesTitle: "Mehr Sprachen",
    languagesBody: "Vamos Tamos spricht jetzt 6 Sprachen, darunter Deutsch und Indonesisch.",
    cta: "Verstanden",
    badge: "Neu",
  },
  common: {
    loading: "Lädt...",
    points: "Pkt",
    court: "Platz",
    team: "Team",
    player: "Spieler",
    rank: "Rang",
    score: "Punkte",
    share: "Ergebnisse teilen",
    linkCopied: "Link in die Zwischenablage kopiert",
    shareFailed: "Turnier ist zu groß, um es per URL zu teilen. Versuche es mit weniger Spielern.",
    and: "und",
    close: "Schließen",
    save: "Speichern",
    cancel: "Abbrechen",
    back: "Zurück",
    yes: "Ja, entfernen",
    no: "Nein, zurück",
    editable: "Bearbeitbar",
    buyMeCoffee: "Spendier mir einen Kaffee",
  },
  results: {
    leastGames: "Wenigste Spiele",
    leastGamesTooltip: "Wenigste gespielte Spiele",
  },
  tournament: {
    new: "Americano oder Mexicano?",
    create: "Turnier erstellen",
    nameRequired: "Turniername ist erforderlich",
    tournamentName: "Turniername",
    round: "Runde",
    completeRound: "Runde abschließen",
    completingRound: "Wird abgeschlossen...",
    nextRoundReady: "Runde #{round} ist bereit",
    endTournament: "Turnier beenden",
    formatRequired: "Bitte Americano oder Mexicano auswählen",
    enterScores: "Bitte alle Punkte eingeben, bevor die Runde abgeschlossen wird",
    bench: "Spieler auf der Bank",
    finalResults: "Turnier",
    finished: "Turnier beendet",
    winner: "Sieger",
    winners: "Sieger",
    with: "mit",
    points: "Punkte",
    summary: "Turnier abgeschlossen in {rounds} Runden mit {players} Spielern auf {courts} Plätzen",
    confirmEnd: "Bist du sicher? Punkte aus dieser Runde werden nicht in die Gesamtwertung aufgenommen",
    yes: "Ja",
    no: "Nein",
    newTournament: 'Neues Turnier starten',
    playedMatches: 'Gespielt',
    pairingComplete: "Paarung abgeschlossen",
    roundSaved: "Runde #{round} gespeichert",
    allPlayersPaired: "Turnier abgeschlossen!",
    continueWithNewPairs: "Turnier fortsetzen",
    viewResults: "Ergebnisse ansehen",
    tournamentEnded: "Turnier beendet",
    roundSettings: "Rundeneinstellungen",
    pointsModeLabel: "Punktebasiert bis {points}",
    timeModeLabel: "Zeitbasiert, {minutes} Min",
    timer: "Timer: {time}",
    timerStatus: "Rundentimer",
    timeUp: "Die Zeit ist um! Bitte beende die Runde und gib die Punkte ein.",
    editRoster: "Aufstellung bearbeiten",
    editRosterTitle: "Spieler & Plätze bearbeiten",
    addPlayer: "Spieler hinzufügen",
    removePlayer: "Entfernen",
    reactivatePlayer: "Reaktivieren",
    inactivePlayers: "Inaktive Spieler",
    applyChanges: "Änderungen übernehmen",
    rosterWarning: "Aktuelle Runde wird neu erstellt und Punkte zurückgesetzt",
    rosterWarningTitle: "Das Übernehmen der Änderungen startet diese Runde neu",
    rosterWarningRegenerate: "Die Teams der aktuellen Runde werden neu gemischt und erstellt.",
    rosterWarningScores: "Bereits für diese Runde eingegebene Punkte werden gelöscht.",
    rosterWarningNewPlayers: "Neue Spieler kommen sofort dazu und werden dieser Runde hinzugefügt.",
    rosterWarningSafe: "Punkte aus früheren, abgeschlossenen Runden bleiben erhalten.",
    minPlayersWarning: "Mindestens 4 aktive Spieler erforderlich",
    courtsReduced: "Plätze auf {courts} reduziert (nicht genug aktive Spieler)",
    playerInactive: "Inaktiv",
    mixedPairsWarning: "Gemischte Paare benötigen gleich viele männliche und weibliche Spieler",
    arrangeFirstRound: "Erste Runde anordnen",
    arrangeFirstRoundTitle: "Erste Runde anordnen",
    arrangeFirstRoundHelp: "Tippe oder klicke auf eine Spielerkarte und dann auf einen anderen Platz, um sie zu tauschen. Nutze die Bank-Reihe, um Spieler ein- und auszuwechseln. Funktioniert auf Mobilgeräten und Desktop gleich.",
    resetFirstRound: "Änderungen zurücksetzen",
    firstRoundUpdated: "Erste Runde aktualisiert",
    manualFirstRoundInvalid: "Jeder aktive Spieler muss in der ersten Runde genau einmal vorkommen.",
    manualFirstRoundMixedPairs: "Gemischte Paare benötigen einen männlichen und einen weiblichen Spieler pro Team.",
    manualFirstRoundBenchSlot: "Bankplatz {number}",
    removePlayerTitle: "Spieler entfernen",
    removePlayerMessage: "Wie möchtest du {player} entfernen?",
    removePlayerExplanation: "Inaktiv setzen: Spieler bleibt in der Rangliste, wird aber keinen Spielen zugewiesen. Vollständig entfernen: Spieler wird komplett aus dem Turnier gelöscht.",
    makeInactive: "Inaktiv setzen (in Rangliste behalten)",
    removeCompletely: "Vollständig entfernen (aus Turnier löschen)",
    removePlayerFinalTitle: "Bist du sicher?",
    removePlayerFinalMessage: "Dadurch werden {player} und alle ihre Punkte dauerhaft aus dem Turnier gelöscht. Dies kann nicht rückgängig gemacht werden."
  },
  tvMode: {
    subtitle: "Übertrage diese Seite auf einen Fernseher, um die Live-Rangliste und Plätze anzuzeigen",
    round: "Runde {round}",
    leaderboard: "Rangliste",
    lastRound: "Letzte Runde",
    onCourt: "Gerade auf dem Platz",
    noGames: "Noch keine aktiven Spiele",
    bench: "Wartet diese Runde",
    missingStateTitle: "Der TV-Modus benötigt einen Turnierlink",
    missingStateBody: "Öffne den TV-Modus aus einem aktiven oder beendeten Turnier, um seine Daten auf dem Bildschirm zu spiegeln.",
    openButton: "TV-Modus öffnen",
  },
  theme: {
    switchToDark: 'Zum dunklen Modus wechseln',
    switchToLight: 'Zum hellen Modus wechseln',
    toggleLabel: 'Farbmodus umschalten',
  },
  playerSetup: {
    title: "Wer spielt mit?",
    addPlayer: "Spieler hinzufügen",
    playerName: "Spieler",
    playerRequired: "Spielername ist erforderlich",
    formatTitle: "Turnierstil",
    formatAmericano: "Americano-Spiel",
    formatMexicano: "Mexicano-Spiel",
    courtsTitle: "Anzahl der Plätze",
    court: "Platz",
    courts: "Plätze",
    startTournament: "Turnier starten",
    loadTeam: "Team laden",
    saveTeam: "Team speichern",
    loadTeamTitle: "Gespeichertes Team laden",
    saveTeamTitle: "Dieses Team speichern",
    teamCode: "Teamname",
    loadTeamHint: "Gib einen einprägsamen Teamnamen ein, um seine Spielerliste wiederzuverwenden.",
    saveTeamHint: "Gib dieser Spielerliste einen einprägsamen Namen, damit du sie nächstes Mal wiederverwenden kannst.",
    savedTeamsTitle: "Deine gespeicherten Teams",
    noSavedTeams: "Noch keine gespeicherten Teams auf diesem Gerät.",
    teamNameRequired: "Bitte einen Teamnamen eingeben",
    noPlayersToSave: "Füge mindestens einen Spielernamen hinzu, bevor du speicherst",
    teamNotFound: "Kein gespeichertes Team mit diesem Namen gefunden",
    teamSaved: "Team gespeichert",
    teamSaveFailed: "Das Team konnte nicht gespeichert werden. Bitte versuche es erneut.",
    teamSavedLocally: "Team auf diesem Gerät gespeichert. Die Freigabe ist noch nicht bestätigt.",
    teamLoaded: "Team geladen",
    updatingTeam: "Beim Speichern wird dein Team \"{name}\" aktualisiert.",
    teamNameTaken: "Dieser Name ist bereits vergeben. Tippe auf den Vorschlag oder gib einen anderen ein.",
    suggestionLabel: "Vorgeschlagener Name",
    load: "Laden",
    createTeam: "Team erstellen",
    pinFourDigits: "PIN (4 Ziffern)",
    pinEnterPrompt: "Gib die 4-stellige PIN des Teams ein.",
    pinCreateWarning: "Du brauchst diese PIN, um das Team später zu laden. Sie kann nicht wiederhergestellt werden \u2014 wenn du sie vergisst, musst du ein neues Team erstellen.",
    pinInvalid: "Die PIN muss 4 Ziffern haben.",
    pinIncorrect: "Falsche PIN. PINs können nicht wiederhergestellt werden \u2014 erstelle ein neues Team, wenn du sie vergessen hast.",
    notEnoughPlayers: "Mindestens {count} Spieler für {courts} Plätze erforderlich",
    duplicateName: "Doppelter Name",
    roundTypeTitle: "Rundentyp",
    roundTypePoints: "Punkte",
    roundTypeTime: "Zeitbasiert",
    targetPoints: "Punkte bis zum Spielende",
    roundMinutes: "Minuten pro Runde",
    timerHint: "Bei 0 ertönt eine Pfeife und ein Banner erscheint.",
    mixedPairsLabel: "Gemischte Paare (M+F-Teams)",
    mexicanoPairingTitle: "Mexicano-Paarung",
    mexicanoPairingHint: "Wähle, wie jeder Vierer-Platz in Teams aufgeteilt wird.",
    mexicanoPairingStandard: "Option 1: #1 + #3 vs #2 + #4",
    mexicanoPairingStandardDescription: "Paart den Erstplatzierten mit dem Drittplatzierten und den Zweiten mit dem Vierten auf jedem Platz.",
    mexicanoPairingAlternate: "Option 2: #1 + #4 vs #2 + #3",
    mexicanoPairingAlternateDescription: "Paart den Besten mit dem Viertplatzierten und die mittleren beiden zusammen auf jedem Platz.",
    gender: "Geschlecht",
    male: "Männlich",
    female: "Weiblich",
    genderBalance: "Gemischte Paare benötigen gleich viele männliche und weibliche Spieler."
  },
  rules: {
    titleAmericano: 'So funktioniert Americano',
    titleMexicano: 'So funktioniert Mexicano',
    teamSetupTitle: 'Team-Aufstellung',
    teamSetupAmericano: 'Spieler werden vor jeder Runde zufällig Teams zugewiesen, um unterschiedliche Team-Kombinationen und Gegner zu gewährleisten.',
    teamPattern13v24: '#1+#3 spielen gegen #2+#4',
    teamPattern14v23: '#1+#4 spielen gegen #2+#3',
    teamSetupMexicano: 'Die Paarungen richten sich nach der Live-Rangliste. Spieler werden nach Rang in Vierergruppen eingeteilt (Top 4, nächste 4 usw.). Auf jedem Platz: {pattern}. Der nächste Platz folgt demselben Muster. So treffen starke Spieler auf starke und schwächere auf schwächere — das Ziel ist eine hohe individuelle Punktzahl, nicht ein einzelnes Siegerpaar.',
    scoringSystemTitle: 'Punktesystem',
    scoringSystem: 'Jede Runde wird auf eine festgelegte Punktzahl oder für eine festgelegte Zeit gespielt. Punkte werden individuell vergeben – gewinnt ein Team z. B. 13–8, erhält jeder Spieler des Siegerteams 13 Punkte und die Verlierer 8.',
    winnerTitle: 'Sieger',
    winner: 'Der Spieler mit den meisten Punkten insgesamt gewinnt und bekommt Applaus von den anderen. :)',
    faqTitle: 'Häufig gestellte Fragen',
    faqFormatsQ: 'Was ist der Unterschied zwischen Americano und Mexicano?',
    faqFormatsA: 'Beim Americano werden die Spieler jede Runde zufällig zusammengelost, sodass jeder mit und gegen jeden spielt. Beim Mexicano richten sich die Paarungen nach der Live-Rangliste und bringen Spieler ähnlicher Stärke zusammen.',
    faqSportsQ: 'Kann ich es für andere Sportarten als Padel nutzen?',
    faqSportsA: 'Ja. Obwohl es für Padel entwickelt wurde, eignen sich die Formate Americano und Mexicano für Pickleball, Tennis, Tischtennis, Badminton und jedes Spiel, das nach Punkten gezählt wird.',
    faqFreeQ: 'Ist es kostenlos und brauche ich ein Konto?',
    faqFreeA: 'Es ist komplett kostenlos und ohne Anmeldung. Die Turniere laufen im Browser und funktionieren offline.',
    faqPlayersQ: 'Wie viele Spieler und Plätze kann ich nutzen?',
    faqPlayersA: 'Beliebig viele Spieler auf einem oder mehreren Plätzen. Die App rotiert die Spieler in jeder Runde automatisch.'
  },
  privacy: {
    title: "Datenschutzerklärung",
    lastUpdated: "Zuletzt aktualisiert",
    dataCollection: "Datenerfassung",
    dataCollectionText: "Vamos Tamos erfasst oder speichert keine personenbezogenen Daten. Alle Turnierdaten bleiben auf deinem Gerät.",
    localStorage: "Lokaler Speicher",
    localStorageText: "Turnierdaten werden lokal im localStorage deines Browsers gespeichert, um den Spielstand zu erhalten. Du kannst diese Daten jederzeit über deine Browsereinstellungen löschen.",
    cookies: "Cookies",
    cookiesText: "Diese App verwendet keine Cookies zum Tracking. Nur der unverzichtbare Browserspeicher (localStorage) wird für die Turnierfunktionen genutzt.",
    thirdParty: "Drittanbieterdienste",
    thirdPartyText: "Wir nutzen Vercel Web Analytics, um anonyme, aggregierte Nutzungsdaten (Seitenaufrufe, Besucherzahlen) zu erfassen. Diese Daten sind datenschutzfreundlich, verfolgen keine einzelnen Nutzer, verwenden keine Cookies und erfassen keine personenbezogenen Informationen. Mehr unter vercel.com/analytics.",
    rights: "Deine Rechte (DSGVO/CCPA)",
    rightsText: "Da keine personenbezogenen Daten erfasst oder verarbeitet werden, behältst du die volle Kontrolle über deine Daten. Du kannst alle lokal gespeicherten Turnierdaten löschen, indem du den localStorage deines Browsers leerst.",
    contact: "Kontakt",
    contactText: "Bei Datenschutzfragen wende dich an: the.adnan@gmail.com",
    backHome: "Zurück zur Startseite"
  }
};
